module.exports = __webpack_public_path__ + "img/image4.5a381c15.jpg";